export default __webpack_public_path__ + "static/media/search-grey.fabae09d.svg";